/* eslint-env jquery */
import Cookies from 'js-cookie';

(function ($) {
  if ($('.eligibility-form').length) {
    $(document).ready(eligibilityFormInit);
  }

  function eligibilityFormInit() {
    if ($('.eligibility-form .gravity-button').length) {
      eligibilityFormHidden();
    }
  }

  function eligibilityFormHidden() {
    const formTitle = Cookies.get('SESSformtitle');
    if (formTitle) {
      $('.eligibility-form .gravity-container .title').html(formTitle);
    }

    $('.eligibility-form .gravity-container').appendTo('.eligibility-form .holder');
    $('.eligibility-form .legal-holder').appendTo('.eligibility-form .holder');
    $('.gravity-button').on('click', buttonClick);
  }

  function buttonClick() {
    $(
      '.eligibility-form .gravity-button, .eligibility-form .gravity-container, .eligibility-form .legal-holder, .eligibility-form h2:not(.title), .eligibility-form .col-7'
    ).slideToggle();
    setTimeout(() => {
      $('.eligibility-form .col-7').remove();
    }, 500);
    Cookies.remove('SESSformtitle');
    Cookies.remove('SESSeligibilityaddress');
  }
})(jQuery);
